// Angular imports
import { EventEmitter, Injector, Input, Output } from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// component import
import { WorkOrderBaseComponent } from './work-order-base-component';

// model import
import { WorkOrderManageWorkFlowParametersDto } from '../_models/work-order-manage-workflow-parameters-dto';
import { WorkFlowWorkOrderLinkResultDto } from '../_models/workflow-work-order-link-result-dto';

export abstract class WorkOrderManageInvoiceBaseComponent extends WorkOrderBaseComponent {
    @Input() communityId: number;
    @Input() workOrderId: number;
    @Input() invoiceIds: Array<number> = [];

    @Output() onInvoiceSelection = new EventEmitter<WorkFlowWorkOrderLinkResultDto>();

    workflowParameter: WorkOrderManageWorkFlowParametersDto = new WorkOrderManageWorkFlowParametersDto();

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    onInvoiceSelectionChange(event: any): void {
        this.workflowParameter.workFlowIdsToLink = event.selectedRowKeys;
        if (Utils.notNullOrEmpty(event.deSelectedRowKeys)) {
            if (Utils.notNullOrEmpty(this.workflowParameter.workFlowIdsToUnLink)) {
                this.workflowParameter.workFlowIdsToUnLink.push(...event.deSelectedRowKeys);
            } else {
                this.workflowParameter.workFlowIdsToUnLink = event.deSelectedRowKeys;
            }
        }
    }

    public getWorkflowParamter(): WorkOrderManageWorkFlowParametersDto {
        this.workflowParameter.communityId = this.communityId;
        this.workflowParameter.workOrderId = this.workOrderId;
        return this.workflowParameter;
    }
}
